module.exports = __webpack_public_path__ + "img/cellcard-kh.7a0b4886.png";